<template>
  <div class="houseStatistical" v-if="permisShow('房源统计')">
    <div class="total">
      <div class="tab">
        <div class="tab-item tab-active">房源分析</div>
        <div class="tab-item" @click="goto()">房源统计</div>
      </div>
      <div class="list">
        <div class="list-item">
          <div class="list-item-content1">
            <div class="list-item-title">总房源(套)</div>
            <div class="list-item-text">出售：{{totalDate.saleAmount}} 出租：{{totalDate.rentAmount}}</div>
          </div>
        </div>
        <div class="list-item">
          <div class="list-item-content2">
            <div class="list-item-title">昨日新增(套)</div>
            <div class="list-item-text">出售：{{totalDate.yesterdaySaleAmount}} 出租：{{totalDate.yesterdayRentAmount}}</div>
          </div>
        </div>
        <div class="list-item">
          <div class="list-item-content3">
            <div class="list-item-title">昨日实勘(套)</div>
            <div class="list-item-text">出售：{{totalDate.yesterdayRealExplorationSaleAmount}}
              出租：{{totalDate.yesterdayRealExplorationRentAmount}}</div>
          </div>
        </div>
        <div class="list-item">
          <div class="list-item-content4">
            <div class="list-item-title">昨日带看(套)</div>
            <div class="list-item-text">出售：{{totalDate.yesterdayTakeLookSaleAmount}}
              出租：{{totalDate.yesterdayTakeLookRentAmount}}</div>
          </div>
        </div>
        <div class="list-item">
          <div class="list-item-content5">
            <div class="list-item-title">昨日成交（套）</div>
            <div class="list-item-text">出售：{{totalDate.yesterdayDealSaleAmount}}
              出租：{{totalDate.yesterdayDealRentAmount}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="total1">
      <!-- 房源状态分析 -->
      <div class="total1-item">
        <div class="title">
          <div>房源状态分析 - 二手房</div>
        </div>
        <div>
          <ve-ring :data="HouseStatisticSaleDate" :settings="HouseStatisticSet"></ve-ring>
        </div>
      </div>
      <div class="total1-item">
        <div class="title">房源状态分析 - 租房</div>
        <div>
          <ve-ring :data="HouseStatisticRentDate" :settings="HouseStatisticSet"></ve-ring>
        </div>
      </div>
    </div>

    <div class="total2">
      <!-- 近半年新增成交对比 -->
      <div class="title">近半年新增成交对比</div>
      <div class="total2-content">
        <div class="total2-content-item">
          <div>
            <ve-histogram :data="nearlyHalfYear" :extend="nearlyHalfYearextend" :settings="nearlyHalfYearSet">
            </ve-histogram>
          </div>
          <div class="total2-content-item-title">新增房源</div>
        </div>
        <div class="total2-content-item">
          <div>
            <ve-histogram :data="HalfYearStatistics" :extend="nearlyHalfYearextend" :settings="HalfYearStatisticsSet">
            </ve-histogram>
          </div>
          <div class="total2-content-item-title">成交单数</div>
        </div>
      </div>
    </div>

    <div class="total3">
      <!-- 二手房-销售分析 -->
      <div class="title">二手房-销售分析</div>
      <div class="total3-top">
        <div>总成交面积：{{saleHouseArea}}㎡，均价：{{saleHouseUnitPrice}}/㎡</div>
        <div>
          <el-select v-model="year" @change="querySaleStatistic" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>年
          <el-select v-model="month" @change="querySaleStatistic" placeholder="请选择">
            <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>月
        </div>
      </div>
      <div class="total3-content">
        <div class="total3-content-item">
          <div>
            <ve-pie :data="areaStatistic" :extend="chartExtend"></ve-pie>
          </div>
          <div class="total3-content-item-title">面积分布</div>
        </div>
        <div class="total3-content-item">
          <div>
            <ve-pie :data="roomStatistic" :extend="chartExtend"></ve-pie>
          </div>
          <div class="total3-content-item-title">户型分布</div>
        </div>
        <div class="total3-content-item">
          <div>
            <ve-bar :data="hotBusinessCircles" :settings="chartSettings"></ve-bar>
          </div>
          <div class="total3-content-item-title">热销商圈</div>
        </div>
      </div>
    </div>

    <div class="total">
      <!-- 业务数据分析 -->
      <div class="title">
        <div>业务数据分析</div>
        <div>
          <span class="report_form_title_tab" v-for="(item,index) in reportabData" :key="index" @click="reportTab(index)" :class="{report_form_title_tab_active:reportActive===index}">{{item}}</span>
        </div>
      </div>
      <ve-line :data="businessAnalysisList"></ve-line>
    </div>
  </div>
</template>

<script>
import {
  queryHouseStatistic,
  querySaleStatistic,
  queryHalfAdd,
  businessAnalysis
} from "@/api/houseStatistical";

import { queryHalfYearStatistics } from "@/api/customStatistical";

export default {
  data() {
    //房源分析设置
    this.HouseStatisticSet = {
      radius: [50, 100]
    };
    this.nearlyHalfYearSet = {
      labelMap: {
        rentAmount: "租房",
        saleAmount: "二手房",
        rentChainRatio: "租房环比",
        saleChainRatio: "二手房环比",
        rentYearOnYear: "租房同比",
        saleYearOnYear: "二手房同比"
      },
      barCategoryGap: "0%",
      // yAxisType: ["KMB", "percent"],
      // yAxisName: ["数值", "比率"],
      showLine: [
        "rentChainRatio",
        "saleChainRatio",
        "rentYearOnYear",
        "saleYearOnYear"
      ]
    };
    this.nearlyHalfYearextend = {
      series: {
        barGap: 0
      },
      tooltip: {
        formatter: function (params) { //自定义函数修改折线图给数据加单位
          // console.log(params)
          let str = '';//声明一个变量用来存储数据

          str += '<div>' + params[0].name + '</div>'; //显示日期的函数

          for (var i = 0; i < params.length; i++) { //图显示的数据较多时需要循环数据，这样才可以成功的给多条数据添加单位

            if (i === 2) {
              str += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + params[i].color + ';"></span>' + params[i].seriesName + '</span> : <span>' + (params[i].value) + '%' + '</br>';

            } else if (i === 3) {
              str += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + params[i].color + ';"></span>' + params[i].seriesName + '</span> : <span>' + (params[i].value) + '%' + '</br>';
            }
            else if (i === 4) {
              str += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + params[i].color + ';"></span>' + params[i].seriesName + '</span> : <span>' + (params[i].value) + '%' + '</br>';
            }
            else if (i === 5) {
              str += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + params[i].color + ';"></span>' + params[i].seriesName + '</span> : <span>' + (params[i].value) + '%' + '</br>';
            }
            else {
              str += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + params[i].color + ';"></span>' + params[i].seriesName + '</span> : <span>' + (params[i].value) + '</br>';

            }

          }
          return str;
        }
      }
    };
    this.HalfYearStatisticsSet = {
      labelMap: {
        houseRent: "租房",
        houseSell: "二手房",
        rentChainRatio: "租房环比",
        buyChainRatio: "二手房环比",
        rentYearOnYear: "租房同比",
        buyYearOnYear: "二手房同比"
      },
      // yAxisType: ["KMB", "percent"],
      // yAxisName: ["数值", "比率"],
      showLine: [
        "rentChainRatio",
        "buyChainRatio",
        "rentYearOnYear",
        "buyYearOnYear"
      ]
    };
    this.chartExtend = {
      legend: {
        bottom: 30
      },
      series: {}
    };
    this.chartSettings = {
      labelMap: {
        amount: "数量"
      }
    };
    let permisList = JSON.parse(sessionStorage.getItem("permisList"));
    return {
      permisList,
      year: "2020",
      month:
        new Date().getMonth() + 1 >= 10
          ? new Date().getMonth() + 1
          : "0" + (new Date().getMonth() + 1),
      options: [
        {
          value: "2019",
          label: "2019"
        },
        {                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
          value: "2020",
          label: "2020"
        },
        {
          value: "2021",
          label: "2021"
        },
        {
          value: "2022",
          label: "2022"
        },
        {
          value: "2023",
          label: "2023"
        },
        {
          value: "2024",
          label: "2024"
        },
        {
          value: "2025",
          label: "2025"
        },
        {
          value: "2026",
          label: "2026"
        },
        {
          value: "2027",
          label: "2027"
        },
        {
          value: "2028",
          label: "2028"
        }
      ],
      options1: [
        {
          value: "",
          label: "不限"
        },
        {
          value: "01",
          label: "01"
        },
        {
          value: "02",
          label: "02"
        },
        {
          value: "03",
          label: "03"
        },
        {
          value: "04",
          label: "04"
        },
        {
          value: "05",
          label: "05"
        },
        {
          value: "06",
          label: "06"
        },
        {
          value: "07",
          label: "07"
        },
        {
          value: "08",
          label: "08"
        },
        {
          value: "09",
          label: "09"
        },
        {
          value: "10",
          label: "10"
        },
        {
          value: "11",
          label: "11"
        },
        {
          value: "12",
          label: "12"
        }
      ],

      // 总计数量
      totalDate: {
        rentAmount: "", //出租总数量
        saleAmount: "", //出售总数量
        yesterdayDealRentAmount: "", //昨日新增出租成交数量
        yesterdayDealSaleAmount: "", //昨日新增出售成交数量
        yesterdayRealExplorationRentAmount: "", //昨日新增租房实勘数量
        yesterdayRealExplorationSaleAmount: "", //昨日新增售房实勘数量
        yesterdayRentAmount: "", //昨日新增出租房源数量
        yesterdaySaleAmount: "", //昨日新增出售房源数量
        yesterdayTakeLookRentAmount: "", //昨日新增出租带看数量
        yesterdayTakeLookSaleAmount: "" //昨日新增出售带看数量
      },

      // 房源状态分析
      HouseStatisticRentDate: {
        columns: ["name", "amount"],
        rows: []
      },
      HouseStatisticSaleDate: {
        columns: ["name", "amount"],
        rows: []
      },

      // 近半年新增房源
      nearlyHalfYear: {
        columns: [
          "yearMonth",
          "saleAmount",
          "rentAmount",
          "rentChainRatio",
          "saleChainRatio",
          "rentYearOnYear",
          "saleYearOnYear"
        ],
        rows: []
      },

      HalfYearStatistics: {
        columns: [
          "date",
          "houseSell",
          "houseRent",
          "rentChainRatio",
          "buyChainRatio",
          "rentYearOnYear",
          "buyYearOnYear"
        ],
        rows: []
      },

      // 二手房销售分析
      areaStatistic: {
        columns: ["name", "amount"],
        rows: []
      },
      hotBusinessCircles: {
        columns: ["tradeAreaName", "amount"],
        rows: []
      },
      roomStatistic: {
        columns: ["name", "amount"],
        rows: []
      },
      saleHouseArea: "",
      saleHouseUnitPrice: "",

      // 业务数据分析
      reportabData: ["本周", "本月"],
      reportActive: 0,
      businessAnalysisList: {
        columns: [],
        rows: []
      }
    };
  },

  mounted() {
    this.queryHouseStatistic();
    this.queryHalfAdd();
    this.querySaleStatistic();
    this.businessAnalysis();
    this.queryHalfYearStatistics();
  },

  methods: {
    permisShow(data) {
      // 权限配置
      let result = this.permisList.indexOf(data);
      // console.log(23432343423, result);
      if (result >= 0) {
        return true;
      } else {
        return false;
      }
    },
    queryHouseStatistic() {
      //房源状态分析
      this.$post(queryHouseStatistic).then(res => {
        if (res.success) {
          this.HouseStatisticSaleDate.rows = res.data.saleStatus;
          this.HouseStatisticRentDate.rows = res.data.rentStatus;
          this.totalDate = res.data;
        }
      });
    },

    queryHalfAdd() {
      // 近半年新增房源
      this.$post(queryHalfAdd).then(res => {
        if (res.success) {
          this.nearlyHalfYear.rows = res.data.nearlyHalfYear;
          // console.log(this.nearlyHalfYear.rows);
        }
      });
    },

    queryHalfYearStatistics() {
      // 近半年成交单数
      let params = {
        houseOrCus: "house"
      };
      this.$post(queryHalfYearStatistics, params).then(res => {
        if (res.success) {
          this.HalfYearStatistics.rows = res.data;
        }
      });
    },

    querySaleStatistic() {
      // 二手房销售分析
      let params = {
        year: this.year,
        month: this.month
      };
      this.$post(querySaleStatistic, params).then(res => {
        if (res.success) {
          this.areaStatistic.rows = res.data.areaStatistic;
          this.hotBusinessCircles.rows = res.data.hotBusinessCircles;
          this.roomStatistic.rows = res.data.roomStatistic;
          this.saleHouseArea = res.data.area;
          this.saleHouseUnitPrice = res.data.unitPrice;
        }
      });
    },

    businessAnalysis() {
      // 房源业务分析
      let params = {
        monthOrWeek: this.reportActive == 0 ? "WEEK" : "MONTH"
      };
      this.$post(businessAnalysis, params).then(res => {
        if (res.success) {
          this.businessAnalysisList = res.data;
        }
      });
    },

    reportTab(index) {
      this.reportActive = index;
      this.businessAnalysis();
    },

    goto() {
      this.$router.push("houseStatisticalList");
    }
  }
};
</script>

<style lang="less">
.houseStatistical {
  padding: 20px 0;
  .title {
    font-size: 16px;
    color: #333333;
    padding: 18px 0;
    border-bottom: 1px solid #e1e1e1;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .total {
    margin: 0 18px;
    padding: 30px 20px;
    background: #ffffff;
    .report_form {
      height: 477px;
      background: #ffffff;
      margin-top: 18px;
      padding: 0 20px;
      overflow: hidden;
      &_title {
        font-size: 16px;
        color: #333333;
        height: 52px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #e1e1e1;
        margin-bottom: 30px;
        > div {
          font-weight: bold;
          font-size: 16px;
        }
        &_tab {
          display: inline-block;
          width: 120px;
          height: 30px;
          text-align: center;
          line-height: 30px;
          border: 1px solid #c7d0ff;
          font-size: 18px;
          color: #666666;
          cursor: pointer;
          &_active {
            background: #5e75e6;
            color: #ffffff;
          }
        }
      }
    }
    .tab {
      display: flex;
      align-items: center;
      margin-bottom: 22px;
      &-item {
        width: 100px;
        height: 36px;
        font-size: 14px;
        line-height: 36px;
        background: #f1f1f1;
        text-align: center;
        cursor: pointer;
      }
      &-active {
        background: #ff9065;
        color: #ffffff;
      }
    }
    .list {
      display: flex;
      align-items: center;
      justify-content: space-around;
      text-align: center;
      &-item {
        flex: 1;
        text-align: center;
        border-left: 5px solid #ffffff;
        border-right: 5px solid #ffffff;
        &-title {
          display: block;
          font-size: 20px;
          color: #ffffff;
          padding-top: 40px;
          padding-bottom: 13px;
        }
        &-text {
          font-size: 16px;
          color: #ffffff;
        }
        &-content1 {
          margin: 0 auto;
          height: 130px;
          background: url("../../assets/statisticalManage/house-01.png")
            no-repeat;
          background-size: cover;
          border-radius: 6px;
        }
        &-content2 {
          margin: 0 auto;
          height: 130px;
          background: url("../../assets/statisticalManage/house-02.png")
            no-repeat;
          background-size: cover;
          border-radius: 6px;
        }
        &-content3 {
          margin: 0 auto;
          height: 130px;
          background: url("../../assets/statisticalManage/house-03.png")
            no-repeat;
          background-size: cover;
          border-radius: 6px;
        }
        &-content4 {
          margin: 0 auto;
          height: 130px;
          background: url("../../assets/statisticalManage/house-04.png")
            no-repeat;
          background-size: cover;
          border-radius: 6px;
        }
        &-content5 {
          margin: 0 auto;
          height: 130px;
          background: url("../../assets/statisticalManage/house-05.png")
            no-repeat;
          background-size: cover;
          border-radius: 6px;
        }
      }
    }
  }
  .total1 {
    margin: 18px 18px;
    display: flex;
    align-items: center;
    &-item:nth-child(1) {
      margin-right: 18px;
    }
    &-item {
      flex: 1;
      padding: 0 20px;
      background: #ffffff;
    }
  }
  .total2 {
    margin: 0 18px;
    padding: 0 20px 20px 20px;
    background: #ffffff;
    &-content {
      background: #f5f5f5;
      display: flex;
      align-items: center;
      margin-top: 30px;
      &-item:nth-child(1) {
        margin-right: 18px;
      }
      &-item {
        flex: 1;
        background: #ffffff;
        &-title {
          text-align: center;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #333;
        }
      }
    }
  }
  .total3 {
    margin: 20px 18px;
    padding: 0 20px 20px 20px;
    background: #ffffff;
    &-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 18px;
      color: #333333;
      padding-top: 40px;
      .el-select {
        margin: 0 8px;
        .el-input__icon {
          line-height: 30px;
        }
        .el-input__inner {
          width: 100px;
          height: 30px;
          background: rgba(245, 245, 245, 1);
          border-radius: 4px;
        }
      }
    }
    &-content {
      background: #f5f5f5;
      display: flex;
      align-items: center;
      margin-top: 30px;
      &-item:nth-child(1) {
        margin-right: 18px;
      }
      &-item:nth-child(2) {
        margin-right: 18px;
      }
      &-item {
        flex: 1;
        background: #ffffff;
        &-title {
          text-align: center;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #333;
        }
      }
    }
  }
}
</style>